<template>
  <nav class="jump-to-nav container">
    <ul>
      <li v-for="item in navigationItems" :key="item.slug">
        <SustainabilityJumpToNavItem :item="item" />
      </li>
    </ul>
  </nav>
</template>

<script>
import sustainabilityContent from "@/content/SustainabilityReport.json";
import SustainabilityJumpToNavItem from "@/components/sustainability/SustainabilityJumpToNavItem.vue";

export default {
  name: "SustainabilityJumpToNav",
  components: {
    SustainabilityJumpToNavItem,
  },
  props: {
    contentPath: {
      type: Array,
      default: () => sustainabilityContent,
    },
    sections: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      content: sustainabilityContent,
    };
  },
  computed: {
    navigationItems() {
      return this.sections.map((section) => {
        return {
          title: section.title,
          slug: section.slug,
        };
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.jump-to-nav {
  padding: 15px 0 60px 0;
  text-align: center;

  @include respond-above(md) {
    padding: 120px 0;
  }
}
</style>
